export default __webpack_public_path__ + "static/media/impacto6.2aac7ba9.png";